import History from './History';

export default History;



// WEBPACK FOOTER //
// ./scripts/elements/History/index.js